import * as React from 'react'
import CmsRouter from '../control/CmsRouter'
import { ClientCookieProvider } from './CookieProviderClient'

export default (
  <ClientCookieProvider>
    <CmsRouter initialLocation={window.location.href} />
  </ClientCookieProvider>
)
